export default __webpack_public_path__ + "static/media/paw.105c2e7c.svg";